import React, { useState } from 'react';
import Draggable from 'react-draggable';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PropTypes from 'prop-types';
import MiscUtils from 'services/MiscUtils';
import { v1 as uuidV1 } from 'uuid';
import './style.scss';
import { DefaultCheckbox } from 'services/UIUtils';
import ContactsSearchModal from 'components/Modals/ContactsSearchModal';
import IconButton from '@material-ui/core/IconButton';
import Icon from 'components/Utils/NewIcon';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import PharmacySearchModal from 'components/Modals/PharmacySearchModal';

const SendFax = ({
  patient,
  title,
  document,
  fax,
  url,
  onClose,
  pharmacy = false,
  initialPharmacies,
}) => {
  const dispatch = useAppDispatch();

  const [number, setNumber] = useState(fax || '');
  const [sending, setSending] = useState(false);
  const [ignoreCoverPage, setIgnoreCoverPage] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  async function getDocumentFileUrl(document) {
    const result = await dispatch(api.Documents.getDocumentFile({ documentId: document.id }), {
      errorTitle: 'Resource Preview',
    });
    if (result) {
      return MiscUtils.getBlobUrl(result);
    }
  }

  async function sendFax(event) {
    event.preventDefault();

    setSending(true);

    if (!url && document) url = await getDocumentFileUrl(document);

    if (!url) return;

    let filename = uuidV1() + '.pdf';

    return MiscUtils.urlToFile(url, 'application/pdf', filename).then((file) => {
      dispatch(
        api.Fax.sendFileFax({
          file,
          fax: number,
          title,
          patientId: patient.id,
          ignoreCoverPage,
        }),
        { errorTitle: 'Send Fax' },
      ).then((result) => {
        setSending(false);
        if (result && onClose) {
          onClose();
          if (onClose) onClose();
        }
      });
    });
  }

  function onSelectContact(contact) {
    setNumber(contact?.fax);
    setShowSearch(false);
  }

  return (
    <Draggable bounds="body" enableUserSelectHack={false}>
      <div className="send-fax box-shadow">
        {showSearch ? (
          pharmacy ? (
            <PharmacySearchModal
              onSelect={onSelectContact}
              onClose={() => setShowSearch(false)}
              initialPharmacies={initialPharmacies}
            />
          ) : (
            <ContactsSearchModal
              patient={patient}
              onSelect={onSelectContact}
              onClose={() => setShowSearch(false)}
            />
          )
        ) : null}
        {!showSearch && (
          <div className="padded-box send-fax-content">
            <span className="large-title">Send Fax</span>
            <div className="row">
              <DefaultTextField
                name="number"
                label="Fax Number"
                value={number}
                onChange={(event) => setNumber(event.target.value)}
              />
              <IconButton onClick={() => setShowSearch(true)} className="blue">
                <Icon
                  src="magnifying-glass"
                  className="white"
                  alt="Search contacts"
                  showTooltip={true}
                />
              </IconButton>
            </div>
            <DefaultCheckbox
              name="template"
              className="mt-3"
              value={ignoreCoverPage}
              onChange={() => setIgnoreCoverPage(!ignoreCoverPage)}
              text="Don't add cover page"
            />
            <div className="row bottom-row" style={{ marginTop: '20px' }}>
              <DefaultButton
                name="Cancel"
                className="red"
                disabled={sending}
                onClick={onClose}
                style={{ marginRight: '5%' }}
              />
              <DefaultButton
                name="Send"
                className="blue"
                disabled={!number}
                loading={sending}
                onClick={sendFax}
              />
            </div>
          </div>
        )}
      </div>
    </Draggable>
  );
};

SendFax.propTypes = {
  fax: PropTypes.string,
  onClose: PropTypes.func,
  url: PropTypes.string,
  attachmentName: PropTypes.string,
  patient: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  pharmacy: PropTypes.boolean,
};

export default SendFax;
